import { m } from 'framer-motion';
import { alpha, Box, Card, Container, Grid, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { MotionViewport, varFade } from '../../components/animate';

const ContentStyle = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundImage: 'url(/assets/background/bg_services.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export default function HomeService() {
  return (
    <ContentStyle>
      <Container component={MotionViewport}>
        <Stack
          component={m.div}
          variants={varFade().inLeft}
          width={1}
          alignItems="center"
          py={{ xs: 5, md: 15 }}
          spacing={5}
        >
          <Stack alignItems="center">
            <Typography variant="h2">L'API-ZF offre des services à l'Investisseur </Typography>
            <Typography variant="h2"> tout au long du cycle d'Investissement</Typography>
          </Stack>

          <Card sx={{ width: '100%' }}>
            <Stack>
              <Grid container columns={15} spacing={0.1}>
                <Grid item xs={5} md={3}>
                  <Stack width={1} direction="row" p={1} bgcolor="primary.main" alignItems="end">
                    <Typography fontWeight="bold" variant="boby2" color="common.white">
                      SERVICES À L'INVESTISSEUR
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={1} bgcolor="black" alignItems="end">
                    <Typography fontWeight="bold" variant="boby2" color="common.white">
                      ATTRACTION
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={1} bgcolor="black" alignItems="end">
                    <Typography fontWeight="bold" variant="boby2" color="common.white">
                      ETABLISSEMENT
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={1} bgcolor="black" alignItems="end">
                    <Typography fontWeight="bold" variant="boby2" color="common.white">
                      RETENTION & EXPANSION
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={1} bgcolor="black" alignItems="end">
                    <Typography fontWeight="bold" variant="boby2" color="common.white">
                      LIENS ET RETOMBÉES
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container columns={15} spacing={0.1}>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      MARKETING
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Promotion pays Promotion ciblée
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2" />
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Contact proactif des Investisseurs établis
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Promotion d'opportunités de retombées
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container columns={15} spacing={0.1}>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      INFORMATION
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Présentations et matériel promotionnel
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Facilitation de la mise en place de l'Investissement
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Communication
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    alignItems="center"
                    direction="row"
                    p={2}
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Sensibilisation
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container columns={15} spacing={0.1}>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      ASSISTANCE
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Réponse aux requêtes
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Suivi de la mise en place de l'Investissement Facilitation des démarches
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} direction="row" p={2} alignItems="center">
                    <Typography fontWeight="bold" variant="boby2">
                      Suivi des requêtes Gestion des griefs Facilitation de démarches
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack width={1} height={1} alignItems="center" direction="row" p={2}>
                    <Typography fontWeight="bold" variant="boby2">
                      Support
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container columns={15} spacing={0.1}>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      PLAIDOYER
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Eliminer les bannieres à l'Investissement
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Eliminer les obstacles pré-opérationnels
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    direction="row"
                    p={2}
                    alignItems="center"
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Eliminer les obstacles opérationnels
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={5} md={3}>
                  <Stack
                    width={1}
                    height={1}
                    alignItems="center"
                    direction="row"
                    p={2}
                    sx={{ bgcolor: (t) => alpha(t.palette.primary.main, 0.2) }}
                  >
                    <Typography fontWeight="bold" variant="boby2">
                      Amélioration de la compétitivité
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Card>

          <Box height={10} width={200} bgcolor="primary.main" />
        </Stack>
      </Container>
    </ContentStyle>
  );
}
